import React,{Fragment,useState} from 'react'
import swal from 'sweetalert'
import {auth} from '../firebase'
import {useHistory} from'react-router-dom'
const Login =()=> {
    const historial = useHistory();
    const[usuario,setUsuario]=useState("");
    const[password,setPassword]=useState("");
   
     const RegistrarUsuario = (e) =>{
        e.preventDefault();
        if(usuario ==="" || password ===""){
            swal( "Oops" ,  "Los campos son requeridos!" ,  "error" )
            return;
        }
        auth.createUserWithEmailAndPassword(usuario,password)
        .then((response)=>{
            swal({
                title: "Exito!",
                text: "Se registro correctamente el usuario!",
                icon: "success",
              });
            document.querySelector("#form").reset();
            historial.push("/admin");
        }).catch(e=>{
            if(e.code ==="auth/invalid-email"){
                swal( "Oops" ,  "Inserte un correo validos!" ,  "error" )
                return;
            }
            if(e.code ==="auth/weak-password"){
                swal( "Oops" ,  "Ingrese una contraseña con 6 a mas caracteres" ,  "error" )
                return;
            }
        });
    }

    const InicioSession = () =>{
        auth.signInWithEmailAndPassword(usuario,password)
        .then((response)=> {historial.push("/admin")})
        .catch((e)=>{
            if(e.code==="auth/wrong-password"){
                swal( "Oops" ,  "Usuario invalido" ,  "error" )
                return;
            }
        })
    }
    return (
        <Fragment>
            <div className="container">
                <div className="row col-md-4 mx-auto mt-5 border border-secondary">
                    <p className="col-md-12 text-center bg-secondary text-white p-4 fs-1">Login con ReactJS</p>
                    <form 
                        className="form-group"
                        onSubmit={RegistrarUsuario}
                        id="form"
                    >
                            <input
                                type="text"
                                className="form-control mb-3 border border-secondary"
                                placeholder="Ingersar Usuario"
                                onChange={(e)=>{setUsuario(e.target.value)}}
                                nombre={usuario}
                            />
                            <input
                                type="password"
                                className="form-control mb-3 border border-secondary"
                                placeholder="Ingersar Contraseña"
                                onChange={(e)=>{setPassword(e.target.value)}}
                            />
                            <button
                                type="submit"
                                className="form-control mb-3 bg-dark text-white  fs-4"
                            >
                                Registrar Usuario
                            </button>
                            <button
                                onClick={InicioSession}
                                type="submit"
                                className="form-control mb-3 bg-primary text-white  fs-4"
                            >
                               Iniciar Session
                            </button>
                            
                    </form>
                </div>
            </div>
        </Fragment>
    )
}

export default Login
